import React, { useEffect } from 'react';
import './Toaster.css';

function Toaster({ message, type = 'info', isVisible, onClose }) {
  useEffect(() => {
    if (isVisible && message) {
      const timer = setTimeout(() => {
        onClose();
      }, 5000); // Auto-fermeture après 5 secondes

      return () => clearTimeout(timer);
    }
  }, [isVisible, message, onClose]);

  if (!isVisible || !message) return null;

  return (
    <div className={`toaster toaster-${type}`}>
      <div className="toaster-content">
        <span className="toaster-message">{message}</span>
        <button className="toaster-close" onClick={onClose}>
          ×
        </button>
      </div>
    </div>
  );
}

export default Toaster;
